export enum ProfilePermissions {
    DATA_EXPORT = 'DATA_EXPORT',
    USER_ROLES_GROUP_PERMISSIONS = 'USER_ROLES/EDIT_GROUP_PERMISSIONS',
    USER_ROLES_GROUP_DELETE = 'USER_ROLES/DELETE_GROUP',
    USER_ROLES_GROUP_ADD_MEMBER = 'USER_ROLES/ADD_GROUP_MEMBER',
    USER_ROLES_GROUP_DELETE_MEMBER = 'USER_ROLES/DELETE_GROUP_MEMBER',
    MARGIN_CALCULATOR = 'MARGIN_CALCULATOR',
    MARGIN_CALCULATOR_EDIT_CATEGORIES_MARGINS = 'MARGIN_CALCULATOR/EDIT_CATEGORIES_MARGINS',
    PRODUCTS = 'PRODUCTS',
    PRODUCTS_READ_ELASTICITY_VALUES = 'PRODUCTS/READ_ELASTICITY_VALUES',
    PRODUCTS_RUN_SKU_SENSITIVITY_CALCULATIONS = 'PRODUCTS/RUN_SKU_SENSITIVITY_CALCULATIONS',
    PRODUCTS_RUN_ELASTICITY_CALCULATIONS = 'PRODUCTS/RUN_ELASTICITY_CALCULATIONS',
    PRODUCTS_RUN_CATEGORY_ROLES_CALCULATIONS = 'PRODUCTS/RUN_CATEGORY_ROLES_CALCULATIONS',
    COMPETITOR_PRICES = 'COMPETITOR_PRICES',
    COMPETITOR_PRICES_READ = 'COMPETITOR_PRICES/READ',
    COMPETITOR_PRICES_APPROVE_IMPORTED_PRICES = 'COMPETITOR_PRICES/APPROVE_IMPORTED_PRICES',
    COMPETITOR_PRICES_DELETE_IMPORTED_PRICES = 'COMPETITOR_PRICES/DELETE_IMPORTED_PRICES',
    PRICES = 'PRICES',
    PRICES_READ = 'PRICES_READ',
    PRICES_READ_PRICE_POINTS = 'PRICES_READ/PRICE_POINTS',
    PRICES_CREATE = 'PRICES_CREATE',
    PRICES_CONFIGURATIONS = 'PRICES_CONFIGURATIONS',
    PRICES_CONFIGURATIONS_APPROVE_SKU_SENSITIVITY_RESULTS = 'PRICES_CONFIGURATIONS/APPROVE_SKU_SENSITIVITY_RESULTS',
    PRICES_CONFIGURATIONS_APPROVE_CATEGORY_ROLES_RESULTS = 'PRICES_CONFIGURATIONS/APPROVE_CATEGORY_ROLES_RESULTS',
    PRICES_CONFIGURATIONS_EDIT_CATEGORY_ROLES_CONFIGURATION = 'PRICES_CONFIGURATIONS/EDIT_CATEGORY_ROLES_CONFIGURATION',
    PRICES_CONFIGURATIONS_EDIT_MARGIN_CALCULATOR_CONFIGURATION = 'PRICES_CONFIGURATIONS/EDIT_MARGIN_CALCULATOR_CONFIGURATION',
    PRICES_CONFIGURATIONS_EDIT_SKU_SENSITIVITY_CONFIGURATION = 'PRICES_CONFIGURATIONS/EDIT_SKU_SENSITIVITY_CONFIGURATION',
    PROMOTIONS = 'PROMOTIONS',
    PROMOTIONS_READ = 'PROMOTIONS_READ',
    BASKETS = 'BASKETS',
    BASKETS_CREATE = 'BASKETS/CREATE',
    BASKETS_DELETE = 'BASKETS/DELETE',
    BASKETS_EDIT = 'BASKETS/EDIT',
    USER_ROLES_EDIT_GROUP = 'USER_ROLES/EDIT_GROUP',
    AUDIT_LOGS = 'AUDIT_LOGS',
    USER_ROLES_CREATE_GROUP = 'USER_ROLES/CREATE_GROUP',
    USER_ROLES_DISABLE_USER_ACCOUNT = 'USER_ROLES/DISABLE_USER_ACCOUNT',
    DATA_EXPORT_EXPORT = 'DATA_EXPORT/EXPORT',
    DATA_IMPORT = 'DATA_IMPORT',
    DATA_IMPORT_IMPORT = 'DATA_IMPORT/IMPORT',
    COMPETITOR_STORES = 'COMPETITOR_STORES',
    COMPETITOR_STORES_READ = 'COMPETITOR_STORES/READ',
    COMPETITOR_STORES_CREATE = 'COMPETITOR_STORES/CREATE',
    COMPETITOR_STORES_DELETE = 'COMPETITOR_STORES/DELETE',
    COMPETITOR_STORES_EDIT = 'COMPETITOR_STORES/EDIT',
    STORES = 'STORES',
    STORES_CREATE = 'STORES/CREATE',
    STORES_DELETE = 'STORES/DELETE',
    STORES_EDIT = 'STORES/EDIT',
    STORES_ASSIGN_COMPETITOR_STORE = 'STORES/ASSIGN_COMPETITOR_STORE',
    SIMULATION = 'SIMULATION',
    SIMULATION_READ = 'SIMULATION/READ',
    SIMULATION_SERVICE = 'SIMULATION_SERVICE',
    SIMULATION_SERVICE_CREATE_SCENARIO = 'SIMULATION_SERVICE/CREATE_SCENARIO',
    SIMULATION_SERVICE_EDIT_SCENARIO = 'SIMULATION_SERVICE/EDIT_SCENARIO',
    SIMULATION_SERVICE_DELETE_SCENARIO = 'SIMULATION_SERVICE/DELETE_SCENARIO',
    SIMULATION_SERVICE_CANCEL_SIMULATION = 'SIMULATION_SERVICE/CANCEL_SIMULATION',
    SIMULATION_SERVICE_APPROVE_SCENARIO = 'SIMULATION_SERVICE/APPROVE_SCENARIO',
    SIMULATION_SERVICE_APPROVE_SIMULATION_RESULTS = 'SIMULATION_SERVICE/APPROVE_SIMULATION_RESULTS',
    SIMULATION_SERVICE_EXPORT_SIMULATION_RESULTS_DETAILS = 'SIMULATION_SERVICE/EXPORT_SIMULATION_RESULTS_DETAILS',
    SIMULATION_SERVICE_EXPORT_SIMULATION_RESULTS = 'SIMULATION_SERVICE/EXPORT_SIMULATION_RESULTS',
    SIMULATION_SERVICE_RUN_SIMULATION = 'SIMULATION_SERVICE/RUN_SIMULATION',
    SIMULATION_SERVICE_MANUAL_EDIT_SIMULATION_RESULTS_PRICE = 'SIMULATION_SERVICE/MANUAL_EDIT_SIMULATION_RESULTS_PRICE',
    SIMULATION_SERVICE_MANUAL_EDIT_SIMULATION_RESULTS_PRICES = 'SIMULATION_SERVICE/MANUAL_EDIT_SIMULATION_RESULTS_PRICES',
    USER_ROLES = 'USER_ROLES',
    USER_ROLES_READ = 'USER_ROLES/READ',
    USER_ROLES_ENABLE_USER_ACCOUNT = 'USER_ROLES/ENABLE_USER_ACCOUNT',
    AUDIT_LOGS_READ = 'AUDIT_LOGS/READ',
    REPORTS_READ = 'REPORTS/READ',
    CurrentAssortment = 'ASSORTMENT/READ_CLASTER_CATEGORIES',
    CurrentAssortmentDetails = 'ASSORTMENT/READ_CLASTER_PRODUCTS',
    CurrentAssortmentEdit = 'ASSORTMENT/ASSIGN_ASSORTMENT_CLUSTERS'
}

export enum ProfilePermissionsNumberEnum {
    DATA_EXPORT = 1,
    USER_ROLES_GROUP_PERMISSIONS,
    USER_ROLES_GROUP_DELETE,
    USER_ROLES_GROUP_ADD_MEMBER,
    USER_ROLES_GROUP_DELETE_MEMBER,
    MARGIN_CALCULATOR,
    MARGIN_CALCULATOR_EDIT_CATEGORIES_MARGINS,
    PRODUCTS,
    PRODUCTS_READ_ELASTICITY_VALUES,
    PRODUCTS_RUN_SKU_SENSITIVITY_CALCULATIONS,
    PRODUCTS_RUN_ELASTICITY_CALCULATIONS,
    PRODUCTS_RUN_CATEGORY_ROLES_CALCULATIONS,
    COMPETITOR_PRICES,
    COMPETITOR_PRICES_READ,
    COMPETITOR_PRICES_APPROVE_IMPORTED_PRICES,
    COMPETITOR_PRICES_DELETE_IMPORTED_PRICES,
    PRICES,
    PRICES_READ,
    PRICES_READ_PRICE_POINTS,
    PRICES_CREATE,
    PRICES_CONFIGURATIONS,
    PRICES_CONFIGURATIONS_APPROVE_SKU_SENSITIVITY_RESULTS,
    PRICES_CONFIGURATIONS_APPROVE_CATEGORY_ROLES_RESULTS,
    PRICES_CONFIGURATIONS_EDIT_CATEGORY_ROLES_CONFIGURATION,
    PRICES_CONFIGURATIONS_EDIT_MARGIN_CALCULATOR_CONFIGURATION,
    PRICES_CONFIGURATIONS_EDIT_SKU_SENSITIVITY_CONFIGURATION,
    BASKETS,
    BASKETS_CREATE,
    BASKETS_DELETE,
    BASKETS_EDIT,
    USER_ROLES_EDIT_GROUP,
    AUDIT_LOGS,
    USER_ROLES_CREATE_GROUP,
    USER_ROLES_DISABLE_USER_ACCOUNT,
    DATA_EXPORT_EXPORT,
    DATA_IMPORT,
    DATA_IMPORT_IMPORT,
    COMPETITOR_STORES,
    COMPETITOR_STORES_READ,
    COMPETITOR_STORES_CREATE,
    COMPETITOR_STORES_DELETE,
    COMPETITOR_STORES_EDIT,
    STORES,
    STORES_CREATE,
    STORES_DELETE,
    STORES_EDIT,
    STORES_ASSIGN_COMPETITOR_STORE,
    SIMULATION,
    SIMULATION_READ,
    SIMULATION_SERVICE,
    SIMULATION_SERVICE_CREATE_SCENARIO,
    SIMULATION_SERVICE_EDIT_SCENARIO,
    SIMULATION_SERVICE_DELETE_SCENARIO,
    SIMULATION_SERVICE_CANCEL_SIMULATION,
    SIMULATION_SERVICE_APPROVE_SCENARIO,
    SIMULATION_SERVICE_APPROVE_SIMULATION_RESULTS,
    SIMULATION_SERVICE_EXPORT_SIMULATION_RESULTS_DETAILS,
    SIMULATION_SERVICE_EXPORT_SIMULATION_RESULTS,
    SIMULATION_SERVICE_RUN_SIMULATION,
    SIMULATION_SERVICE_MANUAL_EDIT_SIMULATION_RESULTS_PRICE,
    SIMULATION_SERVICE_MANUAL_EDIT_SIMULATION_RESULTS_PRICES,
    USER_ROLES,
    USER_ROLES_READ,
    USER_ROLES_ENABLE_USER_ACCOUNT,
    AUDIT_LOGS_READ,
    CurrentAssortment,
    CurrentAssortmentDetails,
    CurrentAssortmentEdit
}

export interface ProfilePermissionListModel {
    Allowed: boolean;
    DisplayName: string;
    Id: number;
    SectionName: string;
    SectionType: string;
}
